/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">All Students</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">User Name</th>
              <th scope="col">Age Bracket</th>
              <th scope="col">Level</th>
              <th scope="col">School Grade</th>
              <th scope="col">Type</th>
              <th scope="col">Class</th>
              <th scope="col">Group #</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Take Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.name }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.username }}</td>
              <td>{{ student.age_bracket }}</td>
              <td>{{ student.level }}</td>
              <td>{{ student.school_grade }}</td>
              <td>{{ student.type }}</td>
              <td>{{ student.class }}</td>
              <td>{{ student.group }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.guardian_name }}</td>
              <td>{{ student.guardian_email }}</td>
              <td>{{ student.guardian_phone }}</td>
              <td>
                <router-link :to="{ name: 'EditStudent', params : {student_id : student._id} }">
                    <button class="btn btn-info btn-sm">Edit</button>
                </router-link>

                <button
                  class="btn btn-success btn-sm btn-block"
                  v-if="student.disabled"
                  @click="activate(student._id)"
                >
                  Activate
                </button>

                <button
                  class="btn btn-dark btn-sm btn-block"
                  v-if="student.disabled == false"
                  @click="deactivate(student._id)"
                >
                  Deactivate
                </button>

                <mdb-container>
                  <!-- trigger modal button -->

                  <!-- cookie modal -->
                  <mdb-modal :show="modalTeacher" removeBackdrop centered>
                    <mdb-modal-body>
                      <form>
                        <div class="form-group col-md-12">
                          <label>Select A Teacher To Assign</label>
                          <p class="text text-primary" v-if="currentTeacherName">Current Teacher: <b>{{ currentTeacherName }}</b></p>
                          <select class="form-control mb-4" v-model="teacher">
                            <option selected disabled>-- Select A Teacher --</option>
                            <option
                              v-for="teacher in teachers"
                              :key="teacher._id"
                              v-bind:value="teacher._id"
                            >
                              {{ teacher.first_name }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group col-md-12">
                          <!-- Sign in button -->
                          <button
                            class="btn btn-info btn-block my-4"
                            @click.prevent="assignTeacher()"
                          >
                            Assign Teacher
                          </button>
                        </div>
                      </form>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="modalTeacher = false; currentTeacherName=''"
                        >
                          Close
                        </button>
                      </div>
                    </mdb-modal-body>
                  </mdb-modal>
                </mdb-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
  name: "Students",
  components: {
    mdbContainer,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      modalTeacher: false,
      students: [],
      currentStudentId: "",
      teachers: [],
      teacher: "",
      currentTeacherName: "",
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    getStudentId(student) {
      this.currentStudentId = student._id;
      this.teacher = student.teacher;
      
      for(let item of this.teachers) {
        if(item._id == this.teacher) {
          this.currentTeacherName = item.first_name;
          break;
        }
      }

      this.modalTeacher = true;
    },

    assignTeacher() {
      let data = {
        teacher: this.teacher,
        student: this.currentStudentId,
      };


      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Assigning Teacher To Student Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/enrollment/assign/teacher", data, config)

        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Teacher Assigned Successfully",
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    activate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/activate", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    deactivate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Disabling Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/deactivate", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Disabled Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teachers = response.data.data.teachers;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
